import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { Activity, Calendar } from 'lucide-react';
import { toast } from 'sonner';

export default function OrgAnalytics() {
  const { api } = useAuth();
  const [usage, setUsage] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/orgs/me/usage-patterns', { params: { days: 30 } });
      setUsage(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to load analytics');
    }
  }, [api]);

  useEffect(() => { load(); }, [load]);

  if (!usage) {
    return <div className="bg-[#F6F8FB] rounded-2xl border border-[#E4E8EF] p-4 h-48 animate-pulse" />;
  }

  return (
    <div className="space-y-4" data-testid="org-analytics">
      <div className="bg-[#F6F8FB] rounded-2xl border border-[#E4E8EF] p-4">
        <h3 className="text-sm font-semibold text-[#0B1620] font-['Bricolage_Grotesque'] mb-3 flex items-center gap-2">
          <Activity className="w-4 h-4 text-[#0B4F3F]" /> Activity by hour (last {usage.period_days} days)
        </h3>
        <ResponsiveContainer width="100%" height={160}>
          <BarChart data={usage.by_hour}>
            <XAxis dataKey="hour" tick={{ fontSize: 10, fill: '#5B6675' }} interval={3} />
            <YAxis tick={{ fontSize: 10, fill: '#5B6675' }} />
            <Tooltip cursor={{ fill: '#EFF2F7' }} contentStyle={{ borderRadius: 8, border: '1px solid #E4E8EF' }} />
            <Bar dataKey="count" fill="#0B4F3F" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-[#F6F8FB] rounded-2xl border border-[#E4E8EF] p-4">
        <h3 className="text-sm font-semibold text-[#0B1620] font-['Bricolage_Grotesque'] mb-3 flex items-center gap-2">
          <Calendar className="w-4 h-4 text-[#0B4F3F]" /> Activity by weekday
        </h3>
        <ResponsiveContainer width="100%" height={160}>
          <BarChart data={usage.by_weekday}>
            <XAxis dataKey="day" tick={{ fontSize: 10, fill: '#5B6675' }} />
            <YAxis tick={{ fontSize: 10, fill: '#5B6675' }} />
            <Tooltip cursor={{ fill: '#EFF2F7' }} contentStyle={{ borderRadius: 8, border: '1px solid #E4E8EF' }} />
            <Bar dataKey="count" fill="#0B4F3F" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
